module.exports = __webpack_public_path__ + "img/D201808_1.b4ac4fc1.jpg";